import React, { FC } from "react";
import { createUseStyles } from "react-jss";
import { motion } from "framer-motion";
import { hoverColor } from "Utils/hoverColor";
import PersonalizationStars from "Assets/images/personalization_stars.svg";
import styles from "./styles";

import Analytics from "../../../analytics/YouVisitAnalytics/analytics";

interface Props {
  actionButtonsConfig: any;
  actionButtonsColorConfig: any;
  className?: string;
  registrationEnabled: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  highContrast?: boolean;
  alwaysShowLearnMore: boolean;
  isPersonalizationEnabled: boolean;
}
const MapActionLinks: FC<Props> = (props: Props) => {
  const {
    actionButtonsConfig: {
      register,
      scheduleVisit,
      applyOnline,
      learnMore,
      showRegistration,
    },
    actionButtonsColorConfig: {
      register: registerColors,
      scheduleVisit: scheduleVisitColors,
      applyOnline: applyOnlineColors,
      learnMore: learnMoreColors,
    },
    registrationEnabled,
    className,
    alwaysShowLearnMore,
    isPersonalizationEnabled,
  } = props;

  const useStyles = createUseStyles(styles);

  const shouldShowRegistration = showRegistration && registrationEnabled;
  const shouldShowLearnMore =
    (alwaysShowLearnMore || !shouldShowRegistration) && learnMore;

  // only show Personalize if registration button text is not customized
  const shouldShowPersonalization =
    isPersonalizationEnabled && register.name === "Register Now";

  // @ts-ignore
  const classes = useStyles({ ...props });
  return (
    <div className={`${classes.container} ${className || ""}`}>
      {shouldShowRegistration && (
        <motion.a
          animate={{
            backgroundColor: registerColors?.bgColor,
            color: registerColors?.fontColor,
          }}
          whileHover={{
            backgroundColor:
              registerColors?.bgColor && hoverColor(registerColors?.bgColor),
          }}
          transition={{
            duration: 0.25,
          }}
          data-testid="register"
          onKeyUp={(e) => {
            if (e.key === " " || e.key === "Enter") register.click(e);
          }}
          onClick={register.click}
          className={`${classes.anchor} ${classes.buttonText} ${classes.registerNow} `}
          rel="noopener noreferrer nofollow"
          target="_blank"
          role="button"
          tabIndex={0}
          id="register-button"
        >
          {shouldShowPersonalization ? (
            <span className={classes.personalize}>
              Personalize
              <PersonalizationStars className={classes.starsIcon} />
            </span>
          ) : (
            register.name
          )}
        </motion.a>
      )}
      {shouldShowLearnMore && (
        <motion.a
          animate={{
            backgroundColor: learnMoreColors?.bgColor,
            color: learnMoreColors?.fontColor,
          }}
          whileHover={{
            backgroundColor:
              learnMoreColors?.bgColor && hoverColor(learnMoreColors?.bgColor),
          }}
          transition={{
            duration: 0.25,
          }}
          data-testid="learnMore"
          href={learnMore.url}
          className={`${classes.anchor} ${classes.buttonText} ${classes.learnMore} `}
          rel="noopener noreferrer nofollow"
          target="_blank"
          tabIndex={0}
          onClick={() => {
            Analytics.sendAnalytics(learnMore.analyticsAction);
          }}
        >
          {learnMore.name}
        </motion.a>
      )}
      {scheduleVisit && (
        <motion.a
          animate={{
            backgroundColor: scheduleVisitColors?.bgColor,
            color: scheduleVisitColors?.fontColor,
          }}
          whileHover={{
            backgroundColor:
              scheduleVisitColors?.bgColor &&
              hoverColor(scheduleVisitColors?.bgColor),
          }}
          transition={{
            duration: 0.25,
          }}
          data-testid="scheduleVisit"
          href={scheduleVisit.url}
          className={`${classes.anchor} ${classes.buttonText} ${classes.scheduleVisit} `}
          rel="noopener noreferrer nofollow"
          target="_blank"
          tabIndex={0}
          onClick={() => {
            Analytics.sendAnalytics(scheduleVisit.analyticsAction);
          }}
        >
          {scheduleVisit.name}
        </motion.a>
      )}
      {applyOnline && (
        <motion.a
          animate={{
            backgroundColor: applyOnlineColors?.bgColor,
            color: applyOnlineColors?.fontColor,
          }}
          whileHover={{
            backgroundColor: hoverColor(applyOnlineColors?.bgColor || ""),
          }}
          transition={{
            duration: 0.25,
          }}
          data-testid="applyOnline"
          href={applyOnline.url}
          className={`${classes.anchor} ${classes.buttonText} ${classes.applyOnline}`}
          rel="noopener noreferrer nofollow"
          target="_blank"
          tabIndex={0}
          onClick={() => {
            Analytics.sendAnalytics(applyOnline.analyticsAction);
          }}
        >
          {applyOnline.name}
        </motion.a>
      )}
    </div>
  );
};
MapActionLinks.defaultProps = {
  className: "",
  highContrast: false,
};
export default MapActionLinks;
